import IcClose from '../../assets/image/ic_x.svg';
import { useTranslation } from '../../hook/useTranslation';

function AgreementTextAge({ onClose = () => {} }) {
  const { t } = useTranslation();
  return (
    <div className="w-full h-full flex flex-col items-center justify-start">
      <div className="w-full flex justify-end items-center gap-2">
        <button type="button" onClick={onClose} className="cursor-pointer">
          <img src={IcClose} alt="close" className="w-[24px] h-[24px]" />
        </button>
      </div>
      <div className="text-[18px] text-[#363636] w-full text-left font-[700] my-[20px]">
        {t('agreement.age.title')}
      </div>
      <div className="w-full my-[20px] grow overflow-y-auto">
        <div className="text-[14px] text-[#363636] w-full text-left font-[400]">
          {t('agreement.age.content').split('\n').map((line, i) => (
            <span key={i}>
              {line}
              {i === 0 && <br />}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AgreementTextAge;
